import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const session_id = m ? decodeURIComponent(m[1]) : null;

    // Clean fragment immediately
    window.history.replaceState(null, "", window.location.pathname);

    if (!session_id) {
      navigate("/admin/login", { replace: true });
      return;
    }

    api.post("/auth/session", { session_id })
      .then((r) => {
        if (r.data.is_admin) {
          navigate("/admin", { replace: true, state: { user: r.data } });
        } else {
          setError("Your account is not authorised for admin access.");
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.detail || "Authentication failed.";
        setError(msg);
      });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#F4F4F0] flex items-center justify-center px-6 text-center" data-testid="auth-callback-page">
      {error ? (
        <div>
          <p className="font-display font-bold text-2xl mb-4">{error}</p>
          <a href="/admin/login" className="link-line font-body text-sm uppercase tracking-[0.25em]" data-testid="auth-error-back-link">
            ← Back to sign-in
          </a>
        </div>
      ) : (
        <p className="font-body text-sm uppercase tracking-[0.25em] text-neutral-500">
          Authenticating…
        </p>
      )}
    </div>
  );
}
